import { sessionStorage, storageKeys } from "./storage";

export const useFunnelData = () => {
  const funnelDetails = JSON.parse(
    sessionStorage.get(storageKeys.generalFunnels) || "{}"
  );

  const funnelKey = funnelDetails.key;
  const funnelProduct = funnelDetails.product;
  const funnelRoutePaths = funnelDetails.paths;

  return { funnelKey, funnelProduct, funnelRoutePaths };
};
